import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import InfoCardsSection from './components/InfoCardsSection';
import CategoriesSection from './components/CategoriesSection';
import WhyChooseSection from './components/WhyChooseSection';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <InfoCardsSection />
      <CategoriesSection />
      <WhyChooseSection />
      <StatsSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
